import { ShaderBase, ShaderUniforms, ShaderAttr } from "./ShaderBase";

export class Shader extends ShaderBase<ShaderUniforms, ShaderAttr> {

}
